export default __webpack_public_path__ + "static/media/teacherW.dd471800.png";